export default __webpack_public_path__ + "static/media/thunderstorm.01a2bc53.jpg";